import { useState } from 'react'
import * as m from '~/paraglide/messages'
import { getLocale, setLocale } from '~/paraglide/runtime.js'
import { Label } from '~/shared/ui/label'
import { Switch } from '~/shared/ui/switch'

export function LanguageSwitch() {
  const [locale, setCurrentLocale] = useState(() => getLocale())

  const handleChange = (english: boolean) => {
    const next = english ? 'en' : 'de'
    if (next !== locale) {
      setLocale(next)
      setCurrentLocale(next)
    }
  }

  return (
    <div className="flex items-center justify-between gap-4">
      <Label className="font-medium text-sm">{m.language()}</Label>
      <div className="flex items-center gap-2 font-medium text-muted-foreground text-xs">
        <span>DE</span>
        <Switch
          checked={locale === 'en'}
          onCheckedChange={handleChange}
          aria-label={m.switchLanguage()}
        />
        <span>EN</span>
      </div>
    </div>
  )
}
